import { AuthError, AuthErrorCode } from '../errors'

/** The refresh and switch-organization actions fail with this when the user
 *  is logged out, before and after the trace headers resolve. */
export const missingRefreshToken = () =>
  AuthError.create({
    code: AuthErrorCode.refreshTokenNotFound,
    message: 'missing refresh token',
  })
